import AuthoriseAndCaptureDialog from './AuthoriseAndCaptureDialog.module';

export default AuthoriseAndCaptureDialog;
